import React, { Component } from 'react';
import { Typography } from '@mui/material';

class ServerError extends Component {
    
    render() {
        return (
          <Typography variant="h5" >
              Connectivity with the server has been interrupted.  Please log out and log back in.  If this persists, please contact AppBind customer support.
            </Typography>
         );
    }
}
  
export default ServerError;